import { render, staticRenderFns } from "./KomlabsRegistration.vue?vue&type=template&id=926a325e&"
import script from "./KomlabsRegistration.vue?vue&type=script&lang=js&"
export * from "./KomlabsRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports